module.exports = __webpack_public_path__ + "img/logo-magazine.a2be156.png";